import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { DetailedTestResults } from '../components/DetailedTestResults';
import { supabase } from '../supabase';
import { LoadingSpinner } from '../components/LoadingSpinner';

interface Test {
  id: string | number;
  name: string;
  duration: number;
  questionsCount: number;
  tags?: string[];
  negativeMarks?: number;
  totalMarks: number;
  Questions?: any[];
}

export const DetailedResultsPage = () => {
  const { testId } = useParams<{ testId: string }>();
  const navigate = useNavigate();
  const { user } = useApp();
  const [results, setResults] = useState(null);
  const [test, setTest] = useState<Test | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadTestData = () => {
      if (!testId) {
        setError("No test ID provided.");
        setIsLoading(false);
        return;
      }

      // Try to get data from localStorage first
      const storedResults = localStorage.getItem(`testResults_${testId}`);
      const storedTest = localStorage.getItem(`testData_${testId}`);
      
      console.log('Loading from localStorage:');
      console.log('storedResults:', storedResults);
      console.log('storedTest:', storedTest);
      
      if (storedResults && storedTest) {
        try {
          const parsedResults = JSON.parse(storedResults);
          const parsedTest = JSON.parse(storedTest);
          console.log('Parsed results:', parsedResults);
          console.log('Parsed test:', parsedTest);
          setResults(parsedResults);
          setTest(parsedTest);
          setIsLoading(false);
          return;
        } catch (e) {
          console.error('Error parsing stored data:', e);
        }
      }

      // If no stored data, try to get from session storage
      const sessionResults = sessionStorage.getItem(`testResults_${testId}`);
      const sessionTest = sessionStorage.getItem(`testData_${testId}`);
      
      if (sessionResults && sessionTest) {
        try {
          setResults(JSON.parse(sessionResults));
          setTest(JSON.parse(sessionTest));
          setIsLoading(false);
          return;
        } catch (e) {
          console.error('Error parsing session data:', e);
        }
      }

      setError("Test results not found. Please take the test first.");
      setIsLoading(false);
    };

    loadTestData();
  }, [testId]);

  useEffect(() => {
    if (error) {
      navigate('/dashboard');
    }
  }, [error, navigate]);


  const handleBack = () => {
    navigate(`/test/${testId}/results`);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    navigate('/signin');
    return null;
  }

  if (!results || !test) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">No test results found</h2>
          <p className="text-gray-600 mb-4">Please complete a test first to view detailed results.</p>
          <button 
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-hover"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white text-black dark:bg-gray-800 dark:text-white">
      <DetailedTestResults
        results={results}
        test={test}
        onBack={handleBack}
      />
    </div>
  );
};